/*
 * @Author: hgc
 * @Date: 2024-07-10 18:19:04
 * @LastEditTime: 2024-07-10 18:20:56
 * @LastEditors: hgc
 * @Description: 
 * @FilePath: \ysz_web_international\src\utils\directive.js
 */

import Vue from "vue"
const imgUrl = require('../assets/images/img_null.png')

// 鼠标经过图片放大效果，可绑定在 img 或其父容器上
Vue.directive("img-zoom", {
  inserted(el) {
    const target = el.tagName === "IMG" ? el : el.querySelector("img")
    if (!target) return

    target.style.transition = "transform 0.5s ease"
    if (el !== target) {
      el.style.overflow = "hidden"
    }

    const onEnter = () => {
      target.style.transform = "scale(1.1)"
    }
    const onLeave = () => {
      target.style.transform = "scale(1)"
    }

    el._imgZoomHandlers = { onEnter, onLeave }
    el.addEventListener("mouseenter", onEnter)
    el.addEventListener("mouseleave", onLeave)
  },
  unbind(el) {
    if (el._imgZoomHandlers) {
      el.removeEventListener("mouseenter", el._imgZoomHandlers.onEnter)
      el.removeEventListener("mouseleave", el._imgZoomHandlers.onLeave)
    }
  },
})

// 图片报错统一处理
Vue.directive("img-error", {
  inserted(el, binding) {
    el.onerror = function () {
      if (binding.value) {
        // 使用默认图片
        el.src = binding.value
      } else {
        // 使用自定义默认图片或者清除错误图片
        el.src = imgUrl
        document.documentElement.scrollTop = 0
      }

      // 防止进入错误回调循环
      el.onerror = null
    }
  },
})
